import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import LoadingOverlay from '../components/LoadingOverlay';
import './AppPage.css';
import './LeavesPage.css';
const labels: any = {
  PENDING: 'Pendiente',
  ACCEPTED: 'Aceptado',
  OBSERVED: 'Observado',
  REJECTED: 'Rechazado',
};
export default function MedicalCertificatesPage() {
  const nav = useNavigate(),
    [items, setItems] = useState<any[]>([]),
    [employees, setEmployees] = useState<any[]>([]),
    [filters, setFilters] = useState<any>({ employeeId: '', status: 'PENDING', from: '', to: '' }),
    [busy, setBusy] = useState(''),
    [error, setError] = useState('');
  const load = async () => {
    try {
      const [c, e] = await Promise.all([
        apiClient.get('/medical-certificates', {
          params: Object.fromEntries(Object.entries(filters).filter(([, v]) => v)),
        }),
        apiClient.get('/employees'),
      ]);
      setItems(c.data);
      setEmployees(e.data);
    } catch {
      setError('No se pudo cargar la bandeja de certificados.');
    }
  };
  useEffect(() => {
    void load();
  }, [filters.employeeId, filters.status, filters.from, filters.to]);
  const review = async (x: any, status: string) => {
    const privateHrObservation = prompt(
      status === 'ACCEPTED'
        ? 'Observación privada de RR. HH. (opcional):'
        : 'Indicá la observación o motivo:'
    );
    if (status !== 'ACCEPTED' && !privateHrObservation) return;
    setBusy('Revisando certificado…');
    try {
      await apiClient.patch(`/medical-certificates/${x.id}/review`, {
        status,
        privateHrObservation: privateHrObservation || undefined,
      });
      await load();
    } catch (e: any) {
      setError(e.response?.data?.message || 'No se pudo revisar.');
    } finally {
      setBusy('');
    }
  };
  const open = async (x: any) => {
    setBusy('Abriendo certificado…');
    try {
      const r = await apiClient.get(`/medical-certificates/${x.id}/file`, { responseType: 'blob' }),
        url = URL.createObjectURL(r.data);
      window.open(url, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      setError('No se pudo abrir el certificado.');
    } finally {
      setBusy('');
    }
  };
  return (
    <div className="app-page">
      {busy && <LoadingOverlay title={busy} />}
      <header className="app-bar">
        <button className="back-button" onClick={() => nav('/dashboard')}>
          ← Volver
        </button>
        <h1>Certificados médicos</h1>
      </header>
      <main className="app-main">
        {error && <div className="error-banner">{error}</div>}
        <section className="panel">
          <div className="panel-heading">
            <div>
              <h2>Bandeja de revisión</h2>
              <p>Información sensible disponible únicamente para perfiles autorizados.</p>
            </div>
            <span className="summary-pill">
              <strong>{items.length}</strong> resultados
            </span>
          </div>
          <div className="leave-filters">
            <select
              value={filters.employeeId}
              onChange={(e) => setFilters({ ...filters, employeeId: e.target.value })}
            >
              <option value="">Todos los empleados</option>
              {employees.map((x) => (
                <option key={x.id} value={x.id}>
                  {x.firstName} {x.lastName}
                </option>
              ))}
            </select>
            <select
              value={filters.status}
              onChange={(e) => setFilters({ ...filters, status: e.target.value })}
            >
              <option value="">Todos los estados</option>
              {Object.entries(labels).map(([v, n]) => (
                <option value={v}>{n as string}</option>
              ))}
            </select>
            <input
              type="date"
              value={filters.from}
              onChange={(e) => setFilters({ ...filters, from: e.target.value })}
            />
            <input
              type="date"
              value={filters.to}
              onChange={(e) => setFilters({ ...filters, to: e.target.value })}
            />
          </div>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Empleado</th>
                  <th>Atención/reposo</th>
                  <th>Profesional</th>
                  <th>Días</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {items.map((x) => (
                  <tr key={x.id}>
                    <td>
                      {x.employee.firstName} {x.employee.lastName}
                      <br />
                      <small>{x.employeeObservation || 'Sin observación del empleado'}</small>
                    </td>
                    <td>
                      {String(x.careDate).slice(0, 10)}
                      <br />
                      {String(x.restStartDate).slice(0, 10)} –{' '}
                      {String(x.expectedEndDate).slice(0, 10)}
                    </td>
                    <td>
                      {x.provider}
                      <br />
                      <small>{x.licenseNumber || 'Sin matrícula informada'}</small>
                      {x.diagnosis && (
                        <>
                          <br />
                          <small>Diagnóstico restringido: {x.diagnosis}</small>
                        </>
                      )}
                    </td>
                    <td>{x.days}</td>
                    <td>{labels[x.status]}</td>
                    <td className="row-actions">
                      <button className="secondary-button" onClick={() => void open(x)}>
                        Ver archivo
                      </button>
                      {x.status === 'PENDING' && (
                        <>
                          <button
                            className="primary-button"
                            onClick={() => void review(x, 'ACCEPTED')}
                          >
                            Aceptar
                          </button>
                          <button
                            className="secondary-button"
                            onClick={() => void review(x, 'OBSERVED')}
                          >
                            Observar
                          </button>
                          <button
                            className="danger-button"
                            onClick={() => void review(x, 'REJECTED')}
                          >
                            Rechazar
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}
